import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 1,
    "name": "Slovenský jazyk",
    "locale": "sk",
    "image": {
      "id": 2,
      "name": "sk.svg",
      "url": "https://api.izolacie-unico.sk/files/sk.svg?ai=0",
      "custom_title": "sk",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 40,
    "name": "Anglický jazyk",
    "locale": "en",
    "image": {
      "id": 57,
      "name": "en.svg",
      "url": "https://api.izolacie-unico.sk/files/NN80g63IxrpyJGsT6pZ7aJ4d1mWOj8C9ZjTui2Yl.svg?ai=0",
      "custom_title": "en",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
